import React,{useState,useMemo} from 'react';
import Dialog from '@mui/material/Dialog';
//import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import BottomButtons from './BottomButtons';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {BookOutline} from './Inc';
//import useStyles from './Styles';

interface Props {
    close():void,
    update(name:string):void,
    line:BookOutline,
    isOpen:boolean,
}

const BookInputName = (props:Props)=> {
    //const classes = useStyles();
    const [value,setValue] = useState("");

    const change = (event: SelectChangeEvent)=>{
        setValue( event.target.value as string );
    }
    const update = ()=>{
        props.update(value);
    }

    const options = useMemo( ()=>{
        let opts:string[] = [];
        const text = props.line.name + props.line.text;
        let max = 20;
        if( text.length<max ){
            max = text.length;
        }
        for( let i=0 ; i<max ; i++ ){
            opts.push( text.substr(0,i+1) );
        }
        return opts.map( (name:string,index:number)=>{
            const key = "opt"+index;
            return (
                <MenuItem key={key} value={name}>{name}</MenuItem>
            )
        })
    },[props.line]);

	if( !props.isOpen ){
        return (null);
    }

    return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}			
		>
			<DialogContent>
				<div style={{fontSize:"90%",marginBottom:"1em"}}>このセリフの役名を選択して下さい。</div>
				<Select
					value={value}
					onChange={change}
					inputProps={{
						name: 'book_name',
						id: 'book_name-simple',
					}}
					style={{width:'100%'}}
				>
					<MenuItem value=''>　</MenuItem>
					{options}
				</Select>
				<BottomButtons button1='決定' onClick1={update} button2='中止' onClick2={props.close} bottom={0}/>
			</DialogContent>
        </Dialog>
    );
}

export default BookInputName;
